import * as React from 'react';
import { Panel, PanelType, FontIcon, ILayerProps, PrimaryButton, DefaultButton } from '@fluentui/react';
import CreateAnalyticsView, { CreateAnalyticsViewRef } from './CreateAnalyticsView';
import { UATConstants } from 'src/Common/Models/UATConstants';

export interface AnalyticsViewCreatePanelProps {
  formMode: string;
  viewId: string;
  onPanelDismiss: Function;
  showPanel: boolean;
  onShowMessage: Function;
}

export interface AnalyticsViewCreatePanelState {
  formMode: string;
  viewId: string;
  activeTab: string;
  isFormValid: boolean;
  showSpinner: boolean;
}

export class AnalyticsViewCreatePanel extends React.Component<
  any,
  AnalyticsViewCreatePanelState,
  AnalyticsViewCreatePanelProps
> {
  private createAnalyticsViewRef: React.RefObject<CreateAnalyticsViewRef>;

  constructor(props: any) {
    super(props);
    this.state = {
      formMode: this.props.formMode,
      viewId: this.props.viewId,
      activeTab: this.props.formMode === 'New' ? 'Generalkey' : '',
      isFormValid: false,
      showSpinner: false,
    };
    this.closeAnalyticsViewPanel = this.closeAnalyticsViewPanel.bind(this);
    this.onShowMessage = this.onShowMessage.bind(this);
    this.handleContinue = this.handleContinue.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updatePanelState = this.updatePanelState.bind(this);
    this.createAnalyticsViewRef = React.createRef<CreateAnalyticsViewRef>();
  }

  private closeAnalyticsViewPanel = () => {
    this.props.onPanelDismiss();
  };

  private onShowMessage = (msg: string) => {
    this.props.onShowMessage(msg);
  };

  private updatePanelState = (activeTab: string, isFormValid: boolean, showSpinner: boolean) => {
    this.setState({ activeTab, isFormValid, showSpinner });
  };

  private handleContinue = () => {
    if (this.createAnalyticsViewRef.current) {
      this.createAnalyticsViewRef.current.handleContinue();
    }
  };

  private handleSubmit = () => {
    if (this.createAnalyticsViewRef.current) {
      this.createAnalyticsViewRef.current.handleSubmit();
    }
  };

  private onRenderFooterContent = (): JSX.Element => {
    const { activeTab, isFormValid, showSpinner } = this.state;

    return (
      <>
        {activeTab !== 'ValidateKey' && (
          <PrimaryButton
            id={'createButton'}
            title={UATConstants.PlaceholdersAndTitles.Continue}
            disabled={showSpinner}
            onClick={this.handleContinue}
            styles={{ root: { marginRight: 8 } }}>
            {UATConstants.PlaceholdersAndTitles.Continue}
          </PrimaryButton>
        )}
        {activeTab === 'ValidateKey' && (
          <PrimaryButton
            id={'createButton'}
            disabled={!isFormValid || showSpinner}
            title={UATConstants.PlaceholdersAndTitles.Save}
            onClick={this.handleSubmit}
            styles={{ root: { marginRight: 8 } }}>
            {UATConstants.PlaceholdersAndTitles.Save}
          </PrimaryButton>
        )}
        <DefaultButton
          title={UATConstants.PlaceholdersAndTitles.Cancel}
          disabled={showSpinner}
          onClick={this.closeAnalyticsViewPanel}>
          {UATConstants.PlaceholdersAndTitles.Cancel}
        </DefaultButton>
      </>
    );
  };

  private layerProps: ILayerProps = {
    eventBubblingEnabled: true,
  };
  render() {
    return (
      <div className='buttonCustomFilterPanelContainer'>
        <div className='customFilterContainer'>
          <Panel
            type={PanelType.custom}
            className='actionPanelLeftPadding'
            layerProps={this.layerProps}
            customWidth={'85%'}
            hasCloseButton={true}
            headerText={this.state.formMode === UATConstants.PlaceholdersAndTitles.ConflictCloseButtonLabel
              ? UATConstants.PlaceholdersAndTitles.NewAnalyticsView
              : UATConstants.PlaceholdersAndTitles.ManageAnalyticsView}
            isOpen={this.props.showPanel}
            onDismiss={() => this.props.onPanelDismiss()}
            closeButtonAriaLabel={UATConstants.PlaceholdersAndTitles.ConflictCloseButtonLabel}
            onRenderFooterContent={this.onRenderFooterContent}
            isFooterAtBottom={true}>
            <CreateAnalyticsView
              ref={this.createAnalyticsViewRef}
              formMode={this.state.formMode}
              viewId={this.state.viewId}
              closePanel={this.closeAnalyticsViewPanel}
              onShowMessage={this.onShowMessage}
              updatePanelState={this.updatePanelState}
            />
          </Panel>
        </div>
      </div>
    );
  }
}
